import React from 'react';
import localizations from '@widgets/localization/localizations.json';
import { Button } from '@fluentui/react-components';
import { Add12Regular } from '@fluentui/react-icons';

export type AddBtnProps = {
  className?: string;
  style?: React.CSSProperties;
  disabled?: boolean;
  onClick: () => void;
};

const AddBtn: React.FC<AddBtnProps> = ({ className, style, disabled, onClick }) => {
  return (
    <>
      <Button
        className={`mv-add-btn ${className}`}
        style={style}
        onClick={onClick}
        icon={<Add12Regular />}
        size={'small'}
        appearance={'primary'}
        disabled={disabled}
      >
        {localizations.addBtn.label}
      </Button>
      <style>
        {`.mv-add-btn svg {
        width: 16px;
        height: 16px;
        margin:-2px 0 -2px -2px;
      } `}
      </style>
    </>
  );
};

export default AddBtn;
